import { render } from "./download.vue?vue&type=template&id=43a2a11f&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"

import "./download.vue?vue&type=style&index=0&id=43a2a11f&scoped=true&lang=css"

import exportComponent from "/studio/gordon/Studio/mylink-intgr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43a2a11f"]])

export default __exports__